<script>
import {useStore} from "@/helpers/store-effect";
import {ref, watch} from "vue";
import {useConnections} from "@/helpers/connections-effect";
import useLoading from "@/helpers/loading-effect";

export default {
  name: "ConnectionSelector",
  template: '#connection-selector-template',
  props: {
    provider: {type: String},
    modelValue: String,
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const store = useStore();
    const modelValue = ref(props.modelValue);
    const connections = useConnections();
    const provider = connections.getProvider(props.provider);
    const providerConections = connections.getConnections(props.provider);

    const {
      isLoading,
      isLoaded,
      startLoading,
      stopLoading,
    } = useLoading(null);

    const connect = async () => {
      startLoading();
      try {
        const connection = await connections.connectWithProvider(props.provider);
      } finally {
        stopLoading();
      }
    };

    watch(() => modelValue.value, value => {
      emit('update:modelValue', value);
    });

    return {
      modelValue,
      provider,
      get connections() {
        return Object.values(providerConections);
      },
      get connection() {
        return providerConections[modelValue.value];
      },
      get isSelectedConnectionValid() {
        return modelValue.value && !this.connection?.expired_at;
      },
      isLoading,
      connect
    }
  },
}
</script>
